export default "__VITE_ASSET__Bpp2bJq2__"